// 获取语言设置
export function getInitialLocale() {
  // 优先从 URL 参数获取语言设置
  const urlLang = getUrlParam('lang');
  if (urlLang) {
    return urlLang;
  }
  
  // 如果 URL 没有指定语言,则使用浏览器语言
  return getBrowserLocale();
}

// 获取 URL 参数
function getUrlParam(name) {
  const url = new URL(window.location.href);
  return url.searchParams.get(name);
}

// 获取浏览器本地语言
function getBrowserLocale() {
  const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language
  return navigatorLocale
}
